$(function () {

	var KEYVISUAL = $("#Keyvisual");
	var HEADER = $("#Header");
	var CONTENTS = $("#Contents");
	var init_contents_top_padding;
	if (device == "pc") {
		init_contents_top_padding = 80;
	} else {
		init_contents_top_padding = 80;
	}


	function setKeyvisualHeight() {
		var h = screen_sizes[1];
		header_fixed_cue = h;
		$(KEYVISUAL).height(h);

		//$(HEADER).css({ "top": h });
		//$("#Categories").css({ 'padding-top': init_contents_top_padding });
		header_fixed_cue = 0;
	}


    if (device != "sp") {
    /*===================================================
  							Womens
  	=====================================================*/
      $(document).ready(function(){
          $('.Categories1.womens').on('init', function(event, slick){
              var totalSlides = slick.slideCount;
              var slidesToShow = slick.options.slidesToShow;
              var slidesToScroll = slick.options.slidesToScroll;
              var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
    
          $('.slide-counter1').text('1/' + totalClicks); // 初期表示
            }).slick({
                    dots: false,
                    arrows: true,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    variableWidth: false,
                    nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
                    prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>'                    
            });
            
            $('.Categories1.womens').on('afterChange', function(event, slick, currentSlide){
                var totalSlides = slick.slideCount;
                var slidesToShow = slick.options.slidesToShow;
                var slidesToScroll = slick.options.slidesToScroll;
                var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
            
                $('.slide-counter1').text((currentSlide / slidesToScroll + 1) + '/' + totalClicks);
            });
      });

     /*===================================================
  							Mens
  	=====================================================*/    
    $(document).ready(function(){
          $('.Categories1.mens').on('init', function(event, slick){
              var totalSlides = slick.slideCount;
              var slidesToShow = slick.options.slidesToShow;
              var slidesToScroll = slick.options.slidesToScroll;
              var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
    
          $('.slide-counter2').text('1/' + totalClicks); // 初期表示
            }).slick({
                    dots: false,
                    arrows: true,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    variableWidth: false,
                    nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
                    prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>'                    
            });
            
            $('.Categories1.mens').on('afterChange', function(event, slick, currentSlide){
                var totalSlides = slick.slideCount;
                var slidesToShow = slick.options.slidesToShow;
                var slidesToScroll = slick.options.slidesToScroll;
                var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
            
                $('.slide-counter2').text((currentSlide / slidesToScroll + 1) + '/' + totalClicks);
            });
      });

      
          /*===================================================
    							Pierre Hardy
    	=====================================================*/
        $(document).ready(function(){
            $('.pierre-hardy').on('init', function(event, slick){
                var totalSlides = slick.slideCount;
                var slidesToShow = slick.options.slidesToShow;
                var slidesToScroll = slick.options.slidesToScroll;
                var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
      
            $('.slide-counter3').text('1/' + totalClicks); // 初期表示
              }).slick({
                      dots: false,
                      arrows: true,
                      infinite: false,
                      speed: 300,
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      variableWidth: false,
                      nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
                      prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>'              
              });
              
              $('.pierre-hardy').on('afterChange', function(event, slick, currentSlide){
                  var totalSlides = slick.slideCount;
                  var slidesToShow = slick.options.slidesToShow;
                  var slidesToScroll = slick.options.slidesToScroll;
                  var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
              
                  $('.slide-counter3').text((currentSlide / slidesToScroll + 1) + '/' + totalClicks);
              });
          });

    }
      /*===================================================
  							切り替えタブ
  	=====================================================*/
      $(document).ready(function() {
        $('.tab-button').click(function() {
          var tabName = $(this).data('tab');
          
          // タブボタンのアクティブ状態を切り替える
          $('.tab-button').removeClass('active');
          $(this).addClass('active');
          
          // コレクションの表示を切り替える
          $('.slick-slider-container').addClass("overflow-hidden-h");
          $('.slick-slider-container[data-collection="' + tabName + '"]').removeClass("overflow-hidden-h");
          $('.slide-counter').hide();
          $('.slide-counter[data-collection="' + tabName + '"]').show();
        });
      });






  

	if (device == "sp") {
  		/*===================================================
    							Womens
    	=====================================================*/
        $(document).ready(function(){
            $('.Categories1.womens').on('init', function(event, slick){
                var totalSlides = slick.slideCount;
                var slidesToShow = slick.options.slidesToShow;
                var slidesToScroll = slick.options.slidesToScroll;
                var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
      
            $('.slide-counter1').text('1/' + totalClicks); // 初期表示
              }).slick({
                      dots: false,
                      arrows: true,
                      infinite: false,
                      speed: 300,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      variableWidth: true,
                      nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
                      prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>'                    
              });
              
              $('.Categories1.womens').on('afterChange', function(event, slick, currentSlide){
                  var totalSlides = slick.slideCount;
                  var slidesToShow = slick.options.slidesToShow;
                  var slidesToScroll = slick.options.slidesToScroll;
                  var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
              
                  $('.slide-counter1').text((currentSlide / slidesToScroll + 1) + '/' + totalClicks);
              });
          });

            /*===================================================
      							Mens
      	=====================================================*/    
        $(document).ready(function(){
              $('.Categories1.mens').on('init', function(event, slick){
                  var totalSlides = slick.slideCount;
                  var slidesToShow = slick.options.slidesToShow;
                  var slidesToScroll = slick.options.slidesToScroll;
                  var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
        
              $('.slide-counter2').text('1/' + totalClicks); // 初期表示
                }).slick({
                        dots: false,
                        arrows: true,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                        nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
                        prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>'                    
                });
                
                $('.Categories1.mens').on('afterChange', function(event, slick, currentSlide){
                    var totalSlides = slick.slideCount;
                    var slidesToShow = slick.options.slidesToShow;
                    var slidesToScroll = slick.options.slidesToScroll;
                    var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
                
                    $('.slide-counter2').text((currentSlide / slidesToScroll + 1) + '/' + totalClicks);
                });
          });

        /*===================================================
    							Pierre Hardy
    	=====================================================*/
        $(document).ready(function(){
            $('.pierre-hardy').on('init', function(event, slick){
                var totalSlides = slick.slideCount;
                var slidesToShow = slick.options.slidesToShow;
                var slidesToScroll = slick.options.slidesToScroll;
                var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
      
            $('.slide-counter3').text('1/' + totalClicks); // 初期表示
              }).slick({
                      dots: false,
                      arrows: false,
                      infinite: false,
                      speed: 300,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      variableWidth: true,
                      nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
                      prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>'              
              });
              
              $('.pierre-hardy').on('afterChange', function(event, slick, currentSlide){
                  var totalSlides = slick.slideCount;
                  var slidesToShow = slick.options.slidesToShow;
                  var slidesToScroll = slick.options.slidesToScroll;
                  var totalClicks = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
              
                  $('.slide-counter3').text((currentSlide / slidesToScroll + 1) + '/' + totalClicks);
              });
          });
    
        
		var slick2 = $('#Categories2').slick({
			dots: false,
			arrows: true,
			nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
			prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>',
			speed: 300,
			infinite: false,
			centerMode: true,
			centerPadding: '10px'
		});
		$('#Categories2').bind('touchstart', function () {
			return true;
		});
		$('#Categories2 .slick-prev').css({ 'opacity': '0.2' });
		slick2.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			if (nextSlide == 0) {
				$('#Categories2 .slick-prev').css({ 'opacity': '0.2' });
			} else if (nextSlide == (slick.slideCount - 1)) {
				$('#Categories2 .slick-next').css({ 'opacity': '0.2' });
			} else {
				$('#Categories2 .slick-prev').css({ 'opacity': '1' });
				$('#Categories2 .slick-next').css({ 'opacity': '1' });
			}
		});

      /*
		var slick3 = $('#SeasonCollection ul').slick({
			dots: false,
			arrows: true,
			nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
			prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>',
			speed: 300,
			infinite: false,
			centerMode: true,
			centerPadding: '10px'
		});
		$('#SeasonCollection ul').bind('touchstart', function () {
			return true;
		});
		$('#SeasonCollection .slick-prev').css({ 'opacity': '0.2' });
		slick3.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			if (nextSlide == 0) {
				$('#SeasonCollection .slick-prev').css({ 'opacity': '0.2' });
			} else if (nextSlide == (slick.slideCount - 1)) {
				$('#SeasonCollection .slick-next').css({ 'opacity': '0.2' });
			} else {
				$('#SeasonCollection .slick-prev').css({ 'opacity': '1' });
				$('#SeasonCollection .slick-next').css({ 'opacity': '1' });
			}
		});
       */
		var slick4 = $('#Blog ul').slick({
			dots: false,
			arrows: true,
			nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
			prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>',
			speed: 300,
			infinite: false,
			centerMode: true,
			centerPadding: '10px'
		});
		$('#Blog ul').bind('touchstart', function () {
			return true;
		});
		$('#Blog .slick-prev').css({ 'opacity': '0.2' });
		slick4.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			if (nextSlide == 0) {
				$('#Blog .slick-prev').css({ 'opacity': '0.2' });
			} else if (nextSlide == (slick.slideCount - 1)) {
				$('#Blog .slick-next').css({ 'opacity': '0.2' });
			} else {
				$('#Blog .slick-prev').css({ 'opacity': '1' });
				$('#Blog .slick-next').css({ 'opacity': '1' });
			}
		});
	}



	/*===================================================
							Window
	=====================================================*/

	//ページが読み込まれたら実行1
	$(window).on('load', function () {
		setKeyvisualHeight();
	});

	//ウィンドウリサイズしたら実行
	$(window).on('resize', function () {

	});

	//スクロールしたら実行
	$(window).on('scroll', function () {
		var ty = $(window).scrollTop();
		//if (ty <= header_fixed_cue) {
		if (ty <= header_fixed_cue) {
			//$(CONTENTS).css({ "padding-top": init_contents_top_padding });
			////$(HEADER).css({ "top": header_fixed_cue });
			//$("#PAGE").removeClass("fixed");
			//console.log("top");
		} else {
			//$(HEADER).css({ "top": 0 });
			//$("#PAGE").addClass("fixed");
			//$(CONTENTS).css({ "padding-top": init_contents_top_padding });
			//console.log("Scroll");
		}
	});


});
